import type { PaginatedMetadataTemplateList } from '@openapi'
import type { GetInstanceMetadataTemplatesPayload } from '@sdk/payload.types'

export function getInstanceMetadataTemplates(
  payload?: GetInstanceMetadataTemplatesPayload,
): Promise<PaginatedMetadataTemplateList> {
  return this.API.request('get_instance_metadata_templates', payload)
}
